/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SegmentationIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Segmentation',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="18" cy="18" r="4.201" />
    <path
      d="M26.149 19.5a8.247 8.247 0 0 1-11.195 6.2l-4.117 6.587A15.969 15.969 0 0 0 33.924 19.5ZM19.5 9.851a8.267 8.267 0 0 1 4.26 2.19l6.319-4.513A15.951 15.951 0 0 0 19.5 2.076ZM31.823 9.97 25.5 14.489a8.222 8.222 0 0 1 .653 2.011h7.775a15.869 15.869 0 0 0-2.105-6.53ZM12.416 24.1A8.26 8.26 0 0 1 16.5 9.851V2.076A15.981 15.981 0 0 0 8.294 30.7Z"
    />
  </svg>`;
};
